<template>
  <div align="center" v-if="params.data">
    <buttonComponent
      :icon="params.icon"
      :action="params.action"
      :title="params.title"
      :actionParams="params.data"
      :btnClass="params.btnClass"
      :disabled="disabled"
    ></buttonComponent>
  </div>
</template>

<script type="text/javascript">
import Vue from "vue";
import buttonComponent from "../../button/buttonComponent.vue";

export default Vue.extend({
  components: {
    buttonComponent: buttonComponent
  },
  computed: {
    disabled: {
      // getter
      get: function() {
        switch (this.params.type) {
          case "int": {
            if (parseInt(this.params.value, 10) <= 0) {
              return true;
            } else {
              return false;
            }
          }
          default:
            return !this.params.value;
        }
      }
    }
  }
});
</script>
